import React from 'react';
import { useAppContext } from '@/contexts/AppContext';
import { Button } from '@/components/common/Button';
import { Input } from '@/components/common/Input';
import { LockerSize, LockerType } from '@/types';
import { assignLocker } from '@/services';
import { useTranslation } from 'react-i18next';

interface LockerSelectionProps {
  onComplete: () => void;
  showHoldTimeInput: boolean;
}

const LockerSelection: React.FC<LockerSelectionProps> = ({ onComplete, showHoldTimeInput }) => {
  const { t } = useTranslation();

  const {
    barcode,
    lockerSize,
    setLockerSize,
    lockerType,
    setLockerType,
    setError,
    setAssignedLocker,
    setHoldTime,
    holdTime,
  } = useAppContext();

  const handleLockerSelect = async () => {
    if (!lockerSize || !lockerType) {
      setError('Please select both locker size and type.');
      return;
    }

    try {
      //const locker = await assignLocker(lockerSize, lockerType);
      //setAssignedLocker(locker.lockerId);
      onComplete();
    } catch (error) {
      setError('An error occurred while assigning a locker. Please try again.');
    }
  };

  return (
    
    <div className="space-y-4">
      <h2 className="text-xl font-bold text-center text-foreground">{t('selectLocker')}</h2>
      <p className="text-foreground">Barcode: {barcode}</p>
      <div className="grid grid-cols-3 gap-2 mt-4 text-center">
        {Object.values(LockerSize).map((size) => (
          <Button
            key={size}
            onClick={() => setLockerSize(size)}
            variant={lockerSize === size ? "default" : "outline"}
            className={`h-14 text-xl font-semibold ${
              lockerSize === size ? "bg-blue-600 text-white" : ""
            }`}
          >
            {t(size)}
          </Button>
        ))}
      </div>
      <div className="grid grid-cols-3 gap-2 mt-4 text-center">
        {Object.values(LockerType).map((type) => (
          <Button
            key={type}
            onClick={() => setLockerType(type)}
            variant={lockerType === type ? "default" : "outline"}
            className={`h-14 text-xl font-semibold ${
              lockerType === type ? "bg-blue-600 text-white" : ""
            }`}
          >
            {t(type)}
          </Button>
        ))}
      </div>
      {showHoldTimeInput && (
        <Input
          type="number"
          placeholder="Hold time (days)"
          value={holdTime || ''}
          onChange={(e) => setHoldTime(parseInt(e.target.value, 10))}
          min={1}
        />
      )}
      <Button onClick={handleLockerSelect} variant="outline" size="lg">{t('confirm')}</Button>
    </div>
  );
};

export default LockerSelection;